<template>
    <div class="managingPatientSize">
        <div style="margin: auto; width: 1200px">
            <template>
                <four>
                    <template #icon>
                        <img v-lazy="require('@/assets/home/icon1.png')" alt="" />
                    </template>
                    <template #title>
                        <p style="font-weight:bold;">
                            业务分布全国&emsp13;|&emsp13;<span style="color: #ffcb4e">12个省</span>
                        </p>
                    </template>
                    <template #text>
                        <p style="text-align: center">
                            4年来专注电子保函服务,业务分布12个省、自治区，累积注册企业6000+，累积出具30000+保函
                        </p>
                    </template>
                </four>
            </template>
        </div>
        <div id="china-map" style="width: 900px; height: 700px"></div>
    </div>
</template>
  
<script>
import four from "@/views/aboutPage/components/four.vue";
// 引入 ECharts 主模块
var echarts = require("echarts/lib/echarts");
// 引入柱状图
require("echarts/lib/chart/bar");
require("echarts/lib/chart/line");
// 引入提示框和标题组件
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");
require("echarts/lib/chart/pie");
require("echarts/lib/component/markLine");
require("echarts/lib/component/geo");
require("echarts/lib/chart/scatter");
require("echarts/lib/chart/map");
export default {
    components: { four },
    data() {
        return {};
    },
    mounted() {
        this.drawCharts();
    },
    methods: {
        drawCharts() {
            let mapChart = this.$echarts.init(document.getElementById("china-map")); //图表初始化，china-map是绑定的元素
            window.onresize = mapChart.resize; //如果容器变大小，自适应从新构图
            let series = []; //存放循环配置项
            let res = []; //存放射线的起始点和结束点位置
            let province = []; //存放有射线的省的名字，以此来拿到对应省份的坐标
            //提前存好的所有省份坐标，用于后面根据名字拿到对应的左边
            let chinaGeoCoordMap = {
                新疆: [86.9023, 41.148],
                西藏: [87.8695, 31.6846],
                内蒙古: [110.5977, 41.3408],
                青海: [95.2402, 35.4199],
                四川: [102.9199, 30.1904],
                黑龙江: [128.1445, 46.7156],
                甘肃: [102.7129, 38.166],
                云南: [101.0652, 24.6807],
                广西: [108.7813, 23.6426],
                湖南: [111.5332, 27.3779],
                陕西: [108.5996, 33.7396],
                广东: [113.8668, 22.8076],
                吉林: [126.1746, 43.5938],
                河北: [115.4004, 38.1688],
                湖北: [112.2363, 30.8572],
                贵州: [106.6113, 26.6385],
                山东: [118.2402, 36.2307],
                江西: [115.7156, 27.99],
                河南: [113.0668, 33.8818],
                辽宁: [123.0438, 41.0889],
                山西: [112.4121, 36.6611],
                安徽: [117.2461, 31.0361],
                福建: [118.3008, 25.9277],
                浙江: [120.498, 29.0918],
                江苏: [119.8586, 32.915],
                重庆: [107.7539, 29.8904],
                宁夏: [105.9961, 37.1096],
                海南: [109.9512, 19.2041],
                台湾: [120.8254, 23.5986],
                北京: [116.4551, 40.2539],
                天津: [117.4219, 39.4189],
                上海: [121.4648, 31.2891],
                香港: [114.6178, 22.3242],
                澳门: [113.5547, 21.6484],
            };
            //后台给的数据
            let lineData = [
                {
                    val: 32, //数据
                    blat: [115.4004, 38.1688], //发射点
                    elon: [86.9023, 41.148], //接收点n
                    // bcitysim: "河北",//发射省的名字
                    // ecitysim: "新疆",//接收省的名字
                },
                {
                    val: 32,
                    blat: [115.4004, 38.1688],
                    elon: [102.9199, 30.1904],
                    // bcitysim: "河北",
                    // ecitysim: "四川",
                },
                {
                    val: 32,
                    blat: [115.4004, 38.1688],
                    elon: [110.5977, 41.3408],
                    // bcitysim: "河北",
                    // ecitysim: "内蒙古",
                },
                {
                    val: 32,
                    blat: [115.4004, 38.1688],
                    elon: [112.4121, 36.6611],
                    // bcitysim: "河北",
                    // ecitysim: "山西",
                },
                {
                    val: 32,
                    blat: [115.4004, 38.1688],
                    elon: [121.4648, 31.2891],
                    // bcitysim: "河北",
                    // ecitysim: "上海",
                },
                {
                    val: 32,
                    blat: [115.4004, 38.1688],
                    elon: [117.4219, 39.4189],
                    // bcitysim: "河北",
                    // ecitysim: "天津",
                },
                {
                    val: 32,
                    blat: [115.4004, 38.1688],
                    elon: [121.4648, 31.2891],
                    // bcitysim: "河北",
                    // ecitysim: "上海",
                },
                {
                    val: 32,
                    blat: [115.4004, 38.1688],
                    elon: [117.2461, 31.0361],
                    // bcitysim: "河北",
                    // ecitysim: "安徽",
                },
                {
                    val: 32,
                    blat: [115.4004, 38.1688],
                    elon: [119.8586, 32.915],
                    // bcitysim: "河北",
                    // ecitysim: "广东",
                },
                {
                    val: 32,
                    blat: [115.4004, 38.1688],
                    elon: [113.8668, 22.8076],
                    // bcitysim: "河北",
                    // ecitysim: "安徽",
                },
                {
                    val: 32,
                    blat: [115.4004, 38.1688],
                    elon: [113.8668, 22.8076],
                    // bcitysim: "河北",
                    // ecitysim: "江苏",
                },
                {
                    val: 32,
                    blat: [115.4004, 38.1688],
                    elon: [107.7539, 29.8904],
                    // bcitysim: "河北",
                    // ecitysim: "重庆",
                },
            ];
            //循环拿到处理好的数据
            for (var i = 0; i < lineData.length; i++) {
                province.push(lineData[i].bcitysim); //存进去每个省的名字
                province.push(lineData[i].ecitysim); //存进去每个省的名字
                res.push({
                    fromName: lineData[i].bcitysim, //发射的省名，保存用于弹框显示
                    toName: lineData[i].ecitysim, //接收的省名，保存用于弹框显示
                    coords: [
                        lineData[i].blat, //发射
                        lineData[i].elon, //接收
                    ],
                    count: lineData[i].val, //数据
                });
            }
            let index_data = new Set(province); //把省的名字去重
            let data_res = []; //定义一个新的变量存放省的坐标

            //注意这里一定要用name和value的形式。不是这个格式的散点图显示不出来
            index_data.forEach((item) => {
                data_res.push({
                    name: item, //每个省的名字
                    value: chinaGeoCoordMap[item], //每个省的坐标
                });
            });
            //循环往series内添加配置项
            series.push(
                {
                    //射线效果图层
                    type: "lines", //类型：射线
                    zlevel: 1, //类似图层效果
                    effect: {
                        show: true, //是否显示图标
                        symbol: "arrow", //箭头图标
                        symbolSize: 5, //图标大小
                        trailLength: 0.02, //特效尾迹长度[0,1]值越大，尾迹越长重
                    },
                    label: {
                        show: true,
                    },
                    // 射线样式
                    lineStyle: {
                        color: "#fff",
                        normal: {
                            color: "#FFB61E",
                            width: 1, //尾迹线条宽度
                            opacity: 0.5, //尾迹线条透明度
                            curveness: 0.1, //尾迹线条曲直度
                        },
                    },
                    //提示框信息
                    // tooltip: {
                    //     formatter: function (param) {
                    //         return (
                    //             param.data.fromName +
                    //             ">" +
                    //             param.data.toName +
                    //             "<br>数量：" +
                    //             param.data.count
                    //         );
                    //     },
                    // },
                    data: res, //拿到射线的起始点和结束点
                },
                //散点图
                {
                    type: "effectScatter", //散点图
                    coordinateSystem: "geo", //这个不能删，删了不显示
                    zlevel: 1,
                    rippleEffect: {
                        //涟漪特效
                        period: 4, //动画时间，值越小速度越快
                        brushType: "stroke", //波纹绘制方式 stroke, fill
                        scale: 4, //波纹圆环最大限制，值越大波纹越大
                    },
                    //设置文字部分
                    label: {
                        normal: {
                            show: true, //省份名显示隐藏
                            position: "right", //省份名显示位置
                            offset: [5, 0], //省份名偏移设置
                            formatter: function (params) {
                                //圆环显示省份名
                                return params.name; //这个名字是根据data中的name来显示的
                            },
                            fontSize: 12, //文字大小
                        },
                        emphasis: {
                            show: true,
                        },
                    },
                    symbol: "circle", //散点图
                    symbolSize: 5, //散点大小
                    itemStyle: {
                        //散点样式
                        normal: {
                            show: true,
                            color: "#fff",
                        },
                    },
                    data: data_res, //处理好后的散点图坐标数组
                },
                //点击高亮
                {
                    type: "map",
                    mapType: "china",
                    zlevel: 1,
                    roam: true,
                    geoIndex: 0,
                    tooltip: {
                        show: true,
                    },
                    itemStyle: {
                        areaColor: "#00196d",
                        borderColor: "#0a53e9",
                    },
                    emphasis: {
                        show: true,
                        label: {
                            normal: {
                                show: true, // 是否显示对应地名
                                textStyle: {
                                    color: "#fff",
                                },
                            },
                        },
                        itemStyle: {
                            areaColor: "#00196d",
                            borderColor: "#0a53e9",
                        },
                    },
                }
            );
            //配置
            let option = {
                //title可要可不要

                // title: {
                //   text: "查查的地图",
                //   textStyle: {
                //     color: "#ffffff",
                //   },
                // },
                legend: {
                    show: true,
                    selected: {},
                    x: "left",
                    orient: "vertical",
                    textStyle: {
                        color: "white",
                    },
                    data: [],
                },
                //鼠标移上去的弹框
                tooltip: {
                    trigger: "item",
                    show: true,
                },
                //geo：这是重点
                geo: {
                    map: "china", //中国地图
                    zoom: 1.2, //缩放倍数
                    roam: true, //是否允许缩放和拖拽地图
                    label: {
                        normal: {
                            show: true, // 是否显示省份名字，现在是隐藏的状态，因为和散点图的名字重叠了。如果需要就true
                            textStyle: {
                                //名字的样式
                                color: "black",
                            },
                        },
                        emphasis: {
                            show: true,
                        },
                    },
                    //地图样式
                    itemStyle: {
                        normal: {
                            // borderColor: "#293171", //地图边框颜色
                            // borderWidth: "2", //地图边框粗细
                            areaColor: "#F7F7F7", //地图背景色
                            // areaColor: '#F7F7F7',
                        },
                        //省份地图阴影
                        emphasis: {
                            areaColor: null,
                            shadowOffsetX: 0,
                            shadowOffsetY: 0,
                            shadowBlur: 20,
                            borderWidth: 0,
                            shadowColor: "#fff",
                        },
                    },
                },
                series: series, //图表配置
            };
            mapChart.setOption(option); //生成图表
            //         // 基于准备好的dom，初始化echarts实例
            //         var chinaMap = echarts.init(document.getElementById("china-map"));
            //         window.onresize = chinaMap.resize; // 窗口或框架被调整大小时执行chinaMap.resize
            //         chinaMap.setOption({
            //             // 进行相关配置
            //             tooltip: {}, // 鼠标移到图里面的浮动提示框
            //             dataRange: {
            //                 show: false,
            //                 min: 0,
            //                 max: 1000,
            //                 text: ["High", "Low"],
            //                 realtime: true,
            //                 calculable: true,
            //                 color: ["orangered", "#FF9B52", "#FFD068"],
            //             },
            //             geo: {
            //                 // 这个是重点配置区
            //                 map: "china", // 表示中国地图
            //                 roam: true,
            //                 label: {
            //                     normal: {
            //                         show: true, // 是否显示对应地名
            //                         textStyle: {
            //                             color: "#fff",
            //                         },
            //                     },
            //                 },
            //                 itemStyle: {
            //                     normal: {
            //                         borderColor: "#293171",
            //                         borderWidth: "2",
            //                         areaColor: "#0A0F33",
            //                     },
            //                     emphasis: {
            //                         areaColor: null,
            //                         shadowOffsetX: 0,
            //                         shadowOffsetY: 0,
            //                         shadowBlur: 20,
            //                         borderWidth: 0,
            //                         shadowColor: "rgba(0, 0, 0, 0.5)",
            //                     },
            //                 },
            //             },
            //             series: [
            //                 {
            //                     type: "scatter",
            //                     coordinateSystem: "geo", // 对应上方配置
            //                 },
            //                 {
            //                     name: "启动次数", // 浮动框的标题
            //                     type: "map",
            //                     geoIndex: 0,
            //                     data: [
            //                         {
            //                             name: "北京",
            //                             value: 599,
            //                         },
            //                         {
            //                             name: "上海",
            //                             value: 142,
            //                         },
            //                         {
            //                             name: "黑龙江",
            //                             value: 44,
            //                         },
            //                         {
            //                             name: "深圳",
            //                             value: 92,
            //                         },
            //                         {
            //                             name: "湖北",
            //                             value: 810,
            //                         },
            //                         {
            //                             name: "四川",
            //                             value: 453,
            //                         },
            //                         {
            //                             name: "新疆",
            //                             value: 666,
            //                         },
            //                     ],
            //                 },
            //             ],
            //         });
        },
    },
};
</script>
  
<style lang="less" scoped>
#china-map {
    z-index: -20;
    margin: -80px auto 50px;
}
</style>